import { setIn, type FormikErrors } from "formik";
import type { OnboardingFormValues } from "./mergePrefillIntoFormValues.js";

export type OnboardingErrors = FormikErrors<OnboardingFormValues>;

const collect = (node: unknown, path: string, into: string[]): void => {
  if (typeof node === "string") {
    into.push(path);
    return;
  }
  if (node && typeof node === "object") {
    for (const [key, child] of Object.entries(node)) {
      collect(child, path ? `${path}.${key}` : key, into);
    }
  }
};

/** Every leaf error as a dotted path (`address.city`, `phones.0.number`). */
export function getErrorPaths(errors: OnboardingErrors): string[] {
  const paths: string[] = [];
  collect(errors, "", paths);
  return paths;
}

const messageAt = (errors: OnboardingErrors, path: string): unknown =>
  path
    .split(".")
    .reduce<unknown>(
      (node, key) =>
        node && typeof node === "object"
          ? Object.entries(node).find(([name]) => name === key)?.[1]
          : undefined,
      errors
    );

/** The errors at the given paths only. */
export function pickErrors(
  errors: OnboardingErrors,
  paths: readonly string[]
): OnboardingErrors {
  let picked: OnboardingErrors = {};
  for (const path of paths) {
    picked = setIn(picked, path, messageAt(errors, path));
  }
  return picked;
}
